import { ResizeObserver as ResizeObserverPolyfill } from '@juggle/resize-observer';
import { autoinject, bindable, bindingMode } from 'aurelia-framework';

@autoinject
export class AfMeasureCustomAttribute {
  @bindable({ primaryProperty: true }) rules: MeasureRule[];
  @bindable({ defaultBindingMode: bindingMode.fromView }) scrollWidth: number;
  @bindable({ defaultBindingMode: bindingMode.fromView }) scrollHeight: number;
  @bindable resized: () => void;

  constructor(private element: Element) { }

  attached() {
    this.sizeChanged(false);
    const ResizeObserver = (<any>window).ResizeObserver || ResizeObserverPolyfill;
    const ro = new ResizeObserver(() => this.sizeChanged(true));
    ro.observe(this.element);
  }

  sizeChanged(raiseEvent: boolean) {
    this.scrollWidth = this.element.scrollWidth;
    this.scrollHeight = this.element.scrollHeight;
    this.applyRules();
    if (raiseEvent && this.resized)
      this.resized();
  }

  rulesChanged() {
    this.applyRules();
  }

  applyRules() {
    const ruleMatches = (rule: MeasureRule) =>
      (rule.from == null || this[rule.property] >= rule.from) &&
      (rule.to == null || this[rule.property] < rule.to);

    if (this.rules != null) {
      const matches = this.rules.filter(r => ruleMatches(r)).map(r => r.class);
      this.element.classList.remove(...this.rules.map(r => r.class).filter(c => !matches.includes(c)));
      this.element.classList.add(...matches);
    }
  }
}

export interface MeasureRule {
  property: string;
  from?: number;
  to?: number;
  class: string;
}
